import '../sass/app.scss';

document.addEventListener('DOMContentLoaded', function() {
    // On click to any modal buttons...
    let modalButtons = document.querySelectorAll('a[data-toggle="modal"]');
    modalButtons.forEach((button) => {
        // Get the div matching this button's "target" attribute
        let selector = button.dataset.target;
        let target = document.querySelector(selector);

        // Get the close button and backdrop so that we can close the modal
        // upon any click to anything outside of it, allowing clicks within
        let closeButton = target.querySelectorAll('.close');
        let closers = [target];
        closeButton.forEach((el) => {
            closers.push(el);
        });

        // Also get the iframe within the modal so that we can stop it
        // from playing whenever the modal is closed
        let player = target.querySelector('iframe');
        let playerSrc = player ? player.getAttribute('src') : '';

        closers.forEach((el) => {
            el.addEventListener('click', function(e) {
                // Replacing the "src" attribute is an easy way to stop an iframe video from playing
                if (player) {
                    player.setAttribute('src', playerSrc);
                }

                // Then, close the modal
                target.classList.toggle('show');
            });
        });
    });
});